import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    lng: ['en', 'uk', 'cs'].includes(localStorage.getItem('help2fix-language'))
      ? localStorage.getItem('help2fix-language')
      : 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          Home: 'Home',
          PostAJob: 'Post a Job',
          About: 'About',
          Support: 'Support',
          AdminPanel: 'Admin Panel',
          Statistics: 'Statistics',
          Office: 'Office',
          Howdy: 'Howdy',
          Greetings: 'We are glad to see you again!',
          ManageJobs: 'Manage Jobs',
          LogInRegister: 'Log In / Register',
          Register: 'Register',
          LogIn: 'Log In',
          DontHaveAnAccount: `Don't have an account?`,
          SignUp: 'Sign Up!',
          PhoneNumber: 'Phone number',
          Phone: 'Phone',
          Password: 'Password',
          RepeatPassword: 'Repeat Password',
          TrustThisDevice: 'Trust this device',
          ForgotPassword: 'Forgot Password?',
          LetsCreateYourAccount: `Let's create your account!`,
          Client: 'Client',
          Master: 'Master',
          FirstName: 'First Name',
          LastName: 'Last Name',
          Notifications: 'Notifications',
          AcceptCandidate: 'Accept candidate',
          Decline: 'Decline',
          DeclineCandidate: 'Decline candidate',
          DeclineCandidateQuestion: 'Decline {{name}} for this job?',
          Cancel: 'Cancel',
          CandidateAccepted: 'Candidate accepted',
          JobCompleted: 'Job completed',
          CompleteAndRate: 'Complete and rate',
          RateMasterRequired: 'Rate the master (required)',
          ReviewOptional: 'Review (optional)',
          RatingRequired: 'Please select a rating from 1 to 5 stars.',
          JobCompletionFailed: 'Could not complete the job. Please try again.',
          InvalidJobCompletionData: 'Please select a valid rating.',
          CommentTooLong: 'The review must not exceed 255 characters.',
          AcceptedMasterNotFound: 'The accepted master was not found for this job.',
          JobAlreadyCompleted: 'This job has already been completed.',
          CompletionSavedThanks: 'Thank you! The job is complete and the rating has been saved.',
          Completed: 'Completed',
          Saving: 'Saving...',
          JobCompletedNotification: 'completed the job and rated you for',
          VerifiedMaster: 'Verified master',
          CandidateAcceptedNotification: 'accepted you for the job',
          CandidateDeclinedNotification: 'declined your application for the job',
          MasterAppliedNotification: 'applied for',
          NewJobNotification: 'posted a new job',
          NewJobsAvailable: 'New jobs ({{count}}) — show',
          NewCandidatesCount: '{{count}} new',
          YouWereAccepted: 'You were accepted',
          MarkAllAsRead: 'Mark all as read',
          appliedForAJob: 'applied for a job',
          YouHaveNoUnreadNotifications: 'You have no unread notifications',
          YouHaveNoUnreadMessages: 'You have no unread messages',
          ViewAllMessages: 'View All Messages',
          Messages: 'Messages',
          Settings: 'Settings',
          Logout: 'Logout',
          mainDescription: {
            part1: `Hire masters or be hired for any job at any time.`,
            part2: `Thousands of users use `,
            part3: ` for quick solutions to everyday problems.`
          },
          Search: 'Search',
          Where: 'Where?',
          Place: 'Place',
          WhatJobYouWant: 'What job you want?',
          JobTitle: 'Job Title',
          JobCategory: 'Job Category',
          JobsPosted: 'Jobs Posted',
          Masters: 'Masters',
          PopularJobCategories: 'Popular Job Categories',
          Categories: 'Categories',
          RecentJobs: 'Recent Jobs',
          BrowseAllJobs: 'Browse All Jobs',
          daysAgo: 'days ago',
          OneDayAgo: '1 day ago',
          ApplyNow: 'Apply Now',
          ApplyForAJob: 'Apply for a Job',
          HighestRatedMasters: 'Highest Rated Masters',
          BrowseAllMasters: 'Browse All Masters',
          MasterProfile: 'Master Profile',
          ViewProfile: 'View Profile',
          ForMasters: 'For Masters',
          ForClients: 'For Clients',
          BrowseJobs: 'Browse Jobs',
          BrowseCandidates: 'Browse Candidates',
          Contact: 'Contact',
          PrivacyPolicy: 'Privacy Policy',
          CookieSettings: 'Cookie settings',
          CookieConsentTitle: 'Cookie preferences',
          CookieConsentText: 'We use necessary storage for authentication, security and preferences. With your permission, Google Maps may load and receive technical information such as your IP address.',
          CookieNecessaryOnly: 'Reject optional',
          CookieAcceptAll: 'Accept optional',
          MapConsentRequired: 'Google Maps is disabled until you allow optional services.',
          OpenCookieSettings: 'Open cookie settings',
          LearnMore: 'Learn more',
          PrivacyPolicyIntro: 'HELP 2 FIX processes account, contact and job information to provide the services requested by clients and masters.',
          EssentialStorageTitle: 'Necessary storage',
          EssentialStorageText: 'Necessary cookies and local storage support login sessions, security, language and consent preferences. They are required for the site to operate.',
          OptionalServicesTitle: 'External and optional services',
          OptionalServicesText: 'Some pages use Google Maps to display locations. Google may process technical information according to its own privacy terms. The site currently does not use advertising pixels.',
          CookieChoiceTitle: 'Managing your choice',
          CookieChoiceText: 'Your selection is stored in this browser. You can reopen the consent panel at any time using Cookie settings in the footer.',
          PrivacyContactText: 'For privacy questions, contact',
          Account: 'Account',
          MyAccount: 'My Account',
          AllRightsReserved: 'All Rights Reserved.',
          HelpfulLinks: 'Helpful Links',
          OfficeNavigation: 'Office Navigation',
          ViewMasterProfile: `Viewing the master's profile`,
          Start: 'Start',
          MyJobListing: 'My Job Listing',
          JobSubmissionForm: 'Job Submission Form',
          Loading: 'Loading',
          Location: 'Location',
          Payment: 'Payment',
          DateAndTime: 'Date and Time',
          JobDescription: 'Job Description',
          ImagesThatMightBeHelpfulInDescribingYourJob: 'Images that might be helpful in describing your job',
          UploadPhotos: 'Upload Photos',
          PhotoUploadConstraints: 'Up to {{count}} photos, maximum {{size}} MB each. Formats:',
          SelectedPhotosCount: 'Selected: {{selected}} / {{count}}',
          MaximumJobPhotos: 'You can upload no more than {{count}} photos.',
          RemovePhoto: 'Remove photo',
          JobPhoto: 'Job photo',
          Upload: 'Upload',
          TypeAddress: 'Type Address',
          Posted: 'Posted',
          ExpiringOn: 'Expiring on',
          MyMaster: 'My Master',
          ManageCandidates: 'Manage Candidates',
          Job: 'Job',
          jobStatus: {
            PendingApproval: 'Pending Approval',
            Expiring: 'Expiring',
            Expired: 'Expired'
          },
          ConfirmTheWorkDone: 'Confirm the work done',
          SaveNewAvatar: 'Save New Avatar',
          Uploading: 'Uploading…',
          AvatarUpdatedSuccessfully: 'Profile photo updated.',
          UnsupportedAvatarFormat: 'Unsupported format. Choose a JPG, PNG or WebP image.',
          AvatarFileTooLarge: 'The file is too large. Maximum size is 5 MB.',
          AvatarFileRequired: 'Choose an image to upload.',
          AvatarUploadFailed: 'Could not upload the photo. Please try again or choose another file.',
          AccountType: 'Account Type',
          Verified: 'Verified',
          Verify: 'Verify',
          Tagline: 'Tagline',
          YourMessage: 'Your Message',
          Send: 'Send',
          DeleteConversation: 'Delete Conversation',
          CompletedJobs: 'Completed Jobs',
          TotalAmountEarned: 'Total Amount Earned',
          JobQRScanner: 'Job QR Scanner',
          ViewJobs: 'View Jobs',
          MyProfile: 'My Profile',
          Nationality: 'Nationality',
          IntroduceYourself: 'Introduce Yourself',
          UploadPassportPhotos: 'Upload passport photos',
          Passport: 'Passport',
          UploadAPhotoOfYourTaxIdentificationNumber: 'Upload a photo of your tax identification number',
          MyDocuments: 'My Documents',
          NewJobs: 'New Jobs',
          NewMasters: 'New Masters',
          AdminPanelNavigation: 'Admin Panel Navigation',
          VerifyTheDocuments: ' Verify the documents',
          Edit: 'Edit',
          AddJobCategory: 'Add Job Category',
          VerificationOfDocuments: 'Verification of documents',
          Editing: 'Editing',
          AddingJobCategories: 'Adding job categories',
          More: 'More',
          Documents: 'Documents',
          NewMaster: 'New Master',
          SaveChanges: 'Save changes',
          Saving: 'Saving...',
          FirstAndLastNameAreRequired: 'First name and last name are required.',
          CouldNotUpdateProfile: 'Could not update profile. Please try again.',
          NewCategory: 'New Category',
          Description: 'Description',
          isPopular: 'is popular',
          Create: 'Create',
          AllCategories: 'All Categories',
          TheMasterDidntProvideAnyDocuments: `The master didn't provide any documents`,
          Question: 'Question',
          Answer: 'Answer',
          AboutMe: 'About Me',
          WorkHistoryAndFeedback: 'Work History and Feedback',
          RatedAs: 'Rated as',
          JobsDone: 'Jobs Done',
          Rehired: 'Rehired',
          ConfirmedMaster: 'Confirmed Master',
          Candidate: {
            part1: 'Candidate',
            part2: 's'
          },
          For: 'For',
          SendMessage: 'Send Message',
          Remove: 'Remove',
          Accept: 'Accept',
          AnyQuestionsFeelFreeToContactUs: 'Any questions? Feel free to contact us!',
          Confirm: 'Confirm',
          Users: 'Users',
          Category: 'Category',
          Currency: 'Currency',
          WhatSpecialistDoYouNeed: 'What specialist do you need?',
          ContactUs: 'Contact Us',
          Menu: 'Menu',
          CloseMenu: 'Close menu',
          OurOffice: 'Our Office',
          BecomeAMaster: 'Become a master',
          MinPayment: 'Min Payment',
          MaxPayment: 'Max Payment',
          AboutTheClient: 'About the Client',
          JobDescription: 'Job Description',
          JobInformation: 'Job Information',
          AppliedForThisJob: 'Applied for this job',
          You: 'You',
          Confirmed: 'Confirmed',
          DatePosted: 'Date Posted',
          SearchResults: 'Search Results',
          ShowFilters: 'Show Filters',
          HideFilters: 'Hide Filters',
          ClickToExpandSidebarWithFilters: 'Click to expand sidebar with filters!',
          NoJobsWereFoundForThisLocation: 'No jobs have been found for this location. Try applying other filters',
          SelectACategory: 'Select a category',
          oneItemSelected: '{{count}} item selected',
          itemsSelected: '{{count}} items selected',
          CategoriesLoadError: 'Could not load categories.',
          NoCategoriesAvailable: 'No categories available',
          JobsLoadError: 'Could not load jobs. Please try again.',
          Retry: 'Retry',
          SortBy: 'Sort by',
          NewestFirst: 'Newest first',
          OldestFirst: 'Oldest first',
          HighestPayment: 'Highest payment',
          SomethingWentWrong: 'Something went wrong',
          LoadingJob: 'Loading job...',
          JobUnavailableTitle: 'Job unavailable',
          JobUnavailableMessage: 'This job was not found or is no longer available to your account.',
          ReloadPageMessage: 'Please reload the page and try again.',
          ReloadPage: 'Reload page',
          SelectANationality: 'Select a nationality',
          SelectACurrency: 'Select a currency',
          InvalidPassword: 'The password must be at least 8 and no more than 20 characters.',
          InvalidTwicePasswordMessage: 'Please check that you have entered your password correctly twice.',
          InvalidPhoneNumberFormat: 'Invalid phone number format',
          SmsMobileNumberRequired: 'SMS can only be sent to a valid mobile number. Landline numbers are not supported.',
          IncorrectPhoneNumberOrPassword: 'Incorrect phone number or password',
          IncorrectPassword: 'Incorrect password',
          IncorrectPhoneNumber: 'Incorrect phone number',
          PhoneNotRegistered: 'This phone number is not registered.',
          RegisterThisNumber: 'Register this number',
          LoginUnavailable: 'Login is temporarily unavailable. Please try again later.',
          SmsTooManyRequests: 'Too many SMS attempts. Please try again later.',
          SmsQuotaExceeded: 'The SMS limit has been reached. Please try again later or contact support.',
          CaptchaCheckFailed: 'The security check failed. Please refresh the page and try again.',
          PhoneAuthenticationDisabled: 'Phone authentication is disabled or SMS is not allowed for this country. Please contact support.',
          SmsBillingNotEnabled: 'SMS billing is not enabled. Please contact support.',
          SmsProviderInternalError: 'The SMS provider returned an internal error. Please try again later.',
          SmsProviderTemporarilyUnavailable: 'The SMS provider temporarily rejected this request. Wait about an hour and try again, or confirm by email.',
          SmsNetworkError: 'Network error while requesting the SMS. Check your connection and try again.',
          PhoneAuthenticationDomainError: 'Phone registration is not configured for this website. Please contact support.',
          SmsRequestTimeout: 'The SMS request took too long. Please try again.',
          SmsDeliveryUnavailable: 'Could not send the SMS. Please try again later or contact support.',
          InvalidSmsCode: 'The SMS code is incorrect.',
          SmsCodeExpired: 'The SMS code has expired. Please request a new code.',
          ResendIn: 'Resend in',
          RegistrationUnavailable: 'Registration could not be completed. Please try again later.',
          ConfirmByEmail: 'Confirm by email', ConfirmBySms: 'Confirm by SMS',
          PleaseCheckYourEmail: 'Please check your email', CheckSpamFolder: 'Also check your Spam folder.',
          ChangeEmail: 'Change email', EmailExistsMessage: 'This email is already registered.',
          PhoneVerificationRequired: 'Phone verification is required.', PhoneOrEmail: 'Phone number or email',
          PhoneNotVerified: 'Phone not verified. You can verify it by SMS later.',
          AccountNotRegistered: 'This account is not registered.', PasswordResetInstructionsSent: 'If this account exists, we sent password reset instructions.',
          PasswordResetEmailRequired: 'Enter the email address linked to your account to reset the password.',
          EmailConfirmedRegistrationCompleted: 'Email confirmed, registration completed.',
          EmailVerificationExpired: 'The confirmation link has expired. Request another email.',
          EmailVerificationRequired: 'Please confirm your email before publishing or applying for jobs.',
          InvalidOrExpiredResetLink: 'This password reset link is invalid or expired.',
          RegistrationCompleted: 'Registration completed',
          RegistrationSuccessful: 'You have been successfully registered.',
          CompleteMasterProfile: 'Complete your master profile to start receiving jobs.',
          PleaseCheckYourPhone: 'Please check your phone',
          WeReSendACodeTo: `We're send a code to`,
          ClickToResend: 'Click to resend',
          DidntHaveACode: `Didn't have a code?`,
          Verification: 'Verification',
          Administrator: 'Administrator',
          Success: 'Success',
          YourDataHasBeenSuccessfullyUpdated: 'Your data has been successfully updated!',
          SaveProfileChanges: 'Save profile changes',
          PhoneExistsMessage: 'The user with this phone number is already registered. \nPlease log in to your account or reset your password if you have forgotten it.',
          PhoneNotExistsMessage: 'The user with this phone number is not registered.',
          MasterWithoutPermission: 'To access this service option, please go through full verification at your office. If you have passed it, please wait for verification confirmation from the site administrator.',
          Only2PassportPhotos: 'Please select only 2 passport photos',
          UploadDocError: 'An error occurred while uploading the photo. Please try this operation again later.',
          DocumentUploadCondition: 'Upload the passport or ID document one side at a time, or select both sides together. Maximum 10 MB per file. Supported formats:',
          DocumentType: 'Document type',
          IdCard: 'ID card (2 sides)',
          PassportBooklet: 'Passport booklet (2 pages)',
          InternationalPassport: 'International passport (1 page)',
          UploadPassportSidesHint: 'Upload the front side and the back side separately. The tax identification document is optional and can be added later.',
          PassportFrontSide: 'Front side / photo page',
          PassportBackSide: 'Back side / registration page',
          ItnOptional: 'Tax identification number (optional)',
          DocumentFileRequired: 'Choose at least one document file.',
          PassportRequired: 'Upload at least the front side or photo page of the passport.',
          DocumentFileTooLarge: 'The document is larger than 10 MB.',
          UnsupportedDocumentFormat: 'Unsupported document format. Choose JPG, PNG, WebP, HEIC or PDF.',
          DocumentConversionFailed: 'The phone image could not be converted. Try JPG, PNG or PDF.',
          DocumentsSentForReview: 'Documents have been uploaded and sent for review.',
          DocumentsPendingReview: 'Documents are pending administrator review.',
          TooManyPassportFiles: 'Select no more than two passport files at once.',
          DeleteCategory: 'Are you sure you want to delete ',
          Yes: 'Yes',
          No: 'No',
          CreateNewFAQ: 'Create new FAQ',
          NotValidPaymentData: 'Not valid payment data',
          hrAgo: 'hours ago',
          minAgo: 'minutes ago',
          now: 'now',
          RespondToTheApplication: 'Respond to the application',
          ProposedPayment: 'Proposed Payment',
          SuggestedLeadTime: 'Suggested Lead Time',
          ICanDoItIn: 'I can do it in',
          EmptyPhoneNumberMessage: 'The phone number field is empty: please enter your phone number',
          EmptyFieldsMessage: 'Empty fields: Please fill in all fields',
          EmptyJobDateTime: 'Please fill in the date and time field',
          JobDescriptionRequired: 'Please describe the job.',
          JobLocationRequired: 'Please select an address from the suggestions.',
          JobPhotoRequired: 'Please upload at least one job photo.',
          JobPublishInvalidData: 'Check the entered information and try again.',
          JobPublishFailed: 'The job could not be published. Please try again. If the problem persists, contact support.',
          PublishingJob: 'Publishing…',
          EmptyMessage: 'Empty message',
          AllowViewingOfMyGeolocation: 'Allow viewing of my geolocation',
          ViewGeolocation: 'View geolocation',
          ViewGeolocationTooltip: 'Your location is required to display job applications near you',
          DeniedPermission: 'You previously declined permission to view your geolocation. To use all the features of the service, enable the permission to view your location for our site in the browser settings.',
          ViewPermissionNotAllowed: 'To access viewing applications nearby, confirm permission to view your location in your account settings.',
          DetermineMyLocation: 'Determine my location',
          DeterminingLocation: 'Determining location…',
          LocationStatus: 'Location',
          LocationDetermined: 'determined',
          LocationNotDetermined: 'not allowed by the browser',
          EnableGeolocationHint: 'Enable geolocation to see jobs near you.',
          GeolocationPermissionDenied: 'Location access was denied.',
          GeolocationPositionUnavailable: 'Your current location is unavailable.',
          GeolocationTimeout: 'Location detection took too long. Please try again.',
          GeolocationUnsupported: 'This browser does not support geolocation.',
          GeolocationSaveError: 'The location was detected but could not be saved. Please try again.',
          GeolocationBrowserInstructions: 'You can still search for jobs and select a region manually in the Location filter.',
          HowToEnableGeolocation: 'How to enable location access',
          GeolocationSafariInstructions: 'Safari: Safari → Settings for help2fix.net → Location → Allow.',
          GeolocationMacInstructions: 'macOS: System Settings → Privacy & Security → Location Services → Safari.',
          GeolocationChromeInstructions: 'Chrome: lock icon in the address bar → Location → Allow.',
          AllCurrencies: 'All currencies',
          SelectCurrencyToFilterPayment: 'Select a currency to filter by payment.',
          NoOpenJobsForCurrency: 'There are no open jobs in this currency.',
          ResetPaymentFilter: 'Reset payment filter',
          EmptyAddress: 'Empty address',
          TheConfirmationLetterHasBeenSentSuccessfully: 'The confirmation letter has been sent successfully. Please confirm your email.',
          ConfirmationLetterSentTo: 'A confirmation email was sent to {{email}}. Please check your inbox.',
          EmailVerificationRateLimit: 'Please wait one minute before requesting another confirmation email.',
          TheEmailIsNotValid: 'The email is not valid.',
          EmailDeliveryUnavailable: 'Email delivery is temporarily unavailable. Please contact support.',
          EmptyNewQuestionOrAnswer: 'New question or answer is empty',
          EnterANewPassword: 'Enter a new password',
          PasswordReset: 'Password reset',
          YourPasswordHasBeenUpdatedSuccessfully: 'Your password has been updated successfully',
          InvalidCode: 'Invalid Code',
          ImageLoadingCondition: 'The size of each image must not exceed 6 MB and be in one of the following formats:',
          ImageSizeNotice: 'The size of the image or images is too large. Please select another image or images.',
          ImageTypeNotice: 'Invalid image or images format. Please select another image or images.',
          Reset: 'Reset',
          ResetAllImages: 'Reset all images',
        }    
      },
    uk: {
        translation: {
          Home: 'Головна',
          PostAJob: 'Створити заявку',
          About: 'Про нас',
          Support: 'Підтримка',
          AdminPanel: 'Адмін Панель',
          Statistics: 'Статистика',
          Office: 'Мій Кабінет',
          Howdy: 'Привіт',
          Greetings: 'Ми раді бачити вас знову!',
          ManageJobs: 'Керуйте заявками',
          LogInRegister: 'Увійти / Зареєструватися',
          Register: 'Зареєструватися',
          LogIn: 'Увійти',
          DontHaveAnAccount: 'Немає акаунту?',
          SignUp: 'Зареєструватися!',
          PhoneNumber: 'Номер телефону',
          Phone: 'Tелефон',
          Password: 'Пароль',
          RepeatPassword: 'Повторіть пароль',
          TrustThisDevice: 'Довіряти цьому пристрою',
          ForgotPassword: 'Забули пароль?',
          LetsCreateYourAccount: 'Давайте створимо ваш акаунт!',
          Client: 'Клієнт',
          Master: 'Майстер',
          FirstName: `Ім'я`,
          LastName: 'Призвіще',
          Notifications: 'Сповіщення',
          AcceptCandidate: 'Прийняти кандидата',
          Decline: 'Відхилити',
          DeclineCandidate: 'Відхилити кандидата',
          DeclineCandidateQuestion: 'Відхилити кандидата {{name}} для цієї заявки?',
          Cancel: 'Скасувати',
          CandidateAccepted: 'Кандидата прийнято',
          JobCompleted: 'Роботу виконано',
          CompleteAndRate: 'Завершити та оцінити',
          RateMasterRequired: 'Оцініть майстра (обов’язково)',
          ReviewOptional: 'Відгук (необов’язково)',
          RatingRequired: 'Оберіть оцінку від 1 до 5 зірок.',
          JobCompletionFailed: 'Не вдалося завершити роботу. Спробуйте ще раз.',
          InvalidJobCompletionData: 'Оберіть коректну оцінку.',
          CommentTooLong: 'Відгук не повинен перевищувати 255 символів.',
          AcceptedMasterNotFound: 'Для цієї роботи не знайдено прийнятого майстра.',
          JobAlreadyCompleted: 'Цю роботу вже завершено.',
          CompletionSavedThanks: 'Дякуємо! Роботу завершено, оцінку збережено.',
          Completed: 'Завершено',
          Saving: 'Збереження...',
          JobCompletedNotification: 'завершив(ла) роботу та оцінив(ла) вас за',
          VerifiedMaster: 'Перевірений майстер',
          CandidateAcceptedNotification: 'прийняв(ла) вас на роботу',
          CandidateDeclinedNotification: 'відхилив(ла) вашу заявку на роботу',
          MasterAppliedNotification: 'подав(ла) заявку на',
          NewJobNotification: 'опублікував(ла) нову роботу',
          NewJobsAvailable: 'Нові роботи ({{count}}) — показати',
          NewCandidatesCount: '{{count}} нових',
          YouWereAccepted: 'Вас прийнято',
          MarkAllAsRead: 'Позначити все як прочитане',
          appliedForAJob: 'подав(ла) заявку',
          YouHaveNoUnreadNotifications: 'У вас немає непрочитаних сповіщень',
          YouHaveNoUnreadMessages: 'У вас немає непрочитаних повідомлень',
          ViewAllMessages: 'Переглянути всі повідомлення',
          Messages: 'Повідомлення',
          Settings: 'Налаштування',
          Logout: 'Вийти',
          mainDescription: {
            part1: `Наймайте майстрів або будьте найняті на будь-яку роботу в будь-який час.`,
            part2: `Тисячі користувачів використовують `,
            part3: ` для швидкого вирішення щоденних проблем.`
          },
          Search: 'Пошук',
          Where: 'Де?',
          Place: 'Місце',
          WhatJobYouWant: 'Яку роботу ти хочеш?',
          JobTitle: 'Назва посади',
          JobCategory: 'Категорія заявки',
          JobsPosted: 'Опублікованих вакансій',
          Masters: 'Майстрів',
          PopularJobCategories: 'Популярні категорії вакансій',
          Categories: 'Категорії',
          RecentJobs: 'Останні заявки',
          BrowseAllJobs: 'Переглянути всі заявки',
          daysAgo: 'днів тому',
          OneDayAgo: '1 день тому',
          ApplyNow: 'Відгукнутись зараз',
          ApplyForAJob: 'Відгукнутись на заявку',
          HighestRatedMasters: 'Майстри з найвищим рейтингом',
          BrowseAllMasters: 'Переглянути всіх майстрів',
          MasterProfile: 'Профіль майстра',
          ViewProfile: 'Переглянути профіль',
          ForMasters: 'Для майстрів',
          ForClients: 'Для клієнтів',
          BrowseJobs: 'Переглянути заявки',
          BrowseCandidates: 'Перегляд кандидатів',
          Contact: 'Контакт',
          PrivacyPolicy: 'Політика конфіденційності',
          CookieSettings: 'Налаштування cookie',
          CookieConsentTitle: 'Налаштування файлів cookie',
          CookieConsentText: 'Ми використовуємо необхідне сховище для авторизації, безпеки та налаштувань. За вашою згодою Google Maps може отримувати технічні дані, зокрема IP-адресу.',
          CookieNecessaryOnly: 'Відхилити додаткові',
          CookieAcceptAll: 'Прийняти додаткові',
          MapConsentRequired: 'Google Maps вимкнено, доки ви не дозволите додаткові сервіси.',
          OpenCookieSettings: 'Відкрити налаштування cookie',
          LearnMore: 'Докладніше',
          PrivacyPolicyIntro: 'HELP 2 FIX обробляє дані акаунта, контакти та інформацію про заявки, щоб надавати послуги клієнтам і майстрам.',
          EssentialStorageTitle: 'Необхідне сховище',
          EssentialStorageText: 'Необхідні cookie та локальне сховище забезпечують авторизацію, безпеку, вибір мови й збереження згоди. Вони потрібні для роботи сайту.',
          OptionalServicesTitle: 'Зовнішні та додаткові сервіси',
          OptionalServicesText: 'На деяких сторінках використовується Google Maps для відображення місць. Google може обробляти технічну інформацію відповідно до власних умов конфіденційності. Сайт наразі не використовує рекламні пікселі.',
          CookieChoiceTitle: 'Керування вибором',
          CookieChoiceText: 'Ваш вибір зберігається в цьому браузері. Панель згоди можна знову відкрити через пункт Налаштування cookie у футері.',
          PrivacyContactText: 'З питань конфіденційності звертайтеся',
          Account: 'Акаунт',
          MyAccount: 'Мій акаунт',
          AllRightsReserved: 'Всі права захищені.',
          HelpfulLinks: 'Корисні Посилання',
          OfficeNavigation: 'Навігація кабінетом',
          ViewMasterProfile: 'Перегляд профілю майстра',
          Start: 'Старт',
          MyJobListing: 'Мій список заявок',
          JobSubmissionForm: 'Форма подання заявки',
          Loading: 'Завантаження',
          Location: 'Місцезнаходження',
          Payment: 'Оплата',
          DateAndTime: 'Дата й час',
          JobDescription: 'Описання роботи',
          ImagesThatMightBeHelpfulInDescribingYourJob: 'Зображення, які можуть бути корисними для опису вашої роботи',
          UploadPhotos: 'Завантажити фотографії',
          PhotoUploadConstraints: 'До {{count}} фотографій, максимум {{size}} МБ кожна. Формати:',
          SelectedPhotosCount: 'Обрано: {{selected}} / {{count}}',
          MaximumJobPhotos: 'Можна завантажити не більше {{count}} фотографій.',
          RemovePhoto: 'Видалити фотографію',
          JobPhoto: 'Фотографія заявки',
          Upload: 'Завантажити',
          TypeAddress: 'Введіть адресу',
          Posted: 'Опубліковано',
          ExpiringOn: 'Термін дії закінчується',
          MyMaster: 'Мій майстер',
          ManageCandidates: 'Керування кандидатами',
          Job: 'Заявка',
          jobStatus: {
            PendingApproval: 'Очікує підтвердження',
            Expiring: 'Термін дії закінчується',
            Expired: 'Термін дії минув'
          },
          ConfirmTheWorkDone: 'Підтвердити виконану роботу',
          SaveNewAvatar: 'Зберегти новий аватар',
          Uploading: 'Завантаження…',
          AvatarUpdatedSuccessfully: 'Фото профілю оновлено.',
          UnsupportedAvatarFormat: 'Формат не підтримується. Виберіть зображення JPG, PNG або WebP.',
          AvatarFileTooLarge: 'Файл завеликий. Максимальний розмір - 5 МБ.',
          AvatarFileRequired: 'Виберіть зображення для завантаження.',
          AvatarUploadFailed: 'Не вдалося завантажити фото. Спробуйте ще раз або виберіть інший файл.',
          AccountType: 'Тип акаунту',
          Verified: 'Перевірено',
          Verify: 'Підтвердити',
          Tagline: 'Tagline',
          YourMessage: 'Твоє повідомлення',
          Send: 'Надіслати',
          DeleteConversation: 'Видалити бесіду',
          CompletedJobs: 'Виконані заявки',
          TotalAmountEarned: 'Загальна зароблена сума',
          JobQRScanner: 'QR-сканер виконаної заявки',
          ViewJobs: 'Переглянути актуальні заявки',
          MyProfile: 'Мій профіль',
          Nationality: 'Національність',
          IntroduceYourself: 'Представтеся', 
          UploadPassportPhotos: 'Завантажте фотографії паспорту',
          Passport: 'Паспорт',
          UploadAPhotoOfYourTaxIdentificationNumber: 'Завантажте фотографію свого податкового номера',
          MyDocuments: 'Мої документи',
          NewJobs: 'Нові Заявки',
          NewMasters: 'Нові Майстри',
          AdminPanelNavigation: 'Навігація панелі адміністратора',
          VerifyTheDocuments: 'Перевірити документи',
          Edit: 'Редагувати',
          AddJobCategory: 'Додайте категорію роботи',
          VerificationOfDocuments: 'Перевірка документів',
          Editing: 'Редагування',
          AddingJobCategories: 'Додавання категорій вакансій',
          More: 'Більше',
          Documents: 'Документи',
          NewMaster: 'Новий майстер',
          SaveChanges: 'Зберегти зміни',
          Saving: 'Збереження...',
          FirstAndLastNameAreRequired: `Ім'я та прізвище обов'язкові.`,
          CouldNotUpdateProfile: 'Не вдалося оновити профіль. Спробуйте ще раз.',
          NewCategory: 'Нова категорія',
          Description: 'Опис',
          isPopular: 'є популярним',
          Create: 'Створити',
          AllCategories: 'Всі категорії',
          TheMasterDidntProvideAnyDocuments: 'Документів майстер не надав',
          Question: 'Запитання',
          Answer: 'Відповідь',
          AboutMe: 'Про мене',
          WorkHistoryAndFeedback: 'Історія роботи та відгуки',
          RatedAs: 'Оцінено як',
          JobsDone: 'Виконано',
          Rehired: 'Перенайняли',
          ConfirmedMaster: 'Підтверджений майстер',
          Candidate: {
            part1: 'Кандидат',
            part2: 'и'
          },
          For: 'Для',
          SendMessage: 'Надіслати повідомлення',
          Remove: 'Видалити',
          Accept: 'Прийняти',
          AnyQuestionsFeelFreeToContactUs: 'Які-небудь питання? Не соромтеся звертатися до нас!',
          Confirm: 'Підтвердити',
          Users: 'Користувачів',
          Category: 'Категорія',
          Currency: 'Валюта',
          WhatSpecialistDoYouNeed: 'Який фахівець вам потрібний?',
          ContactUs: `Зв'язатися з нами`,
          Menu: 'Меню',
          CloseMenu: 'Закрити меню',
          OurOffice: 'Наш Офіс',
          BecomeAMaster: 'Стати майстром',
          MinPayment: 'Мінімальна плата',
          MaxPayment: 'Максимальна плата',
          AboutTheClient: 'Про клієнта',
          JobDescription: 'Описання роботи',
          JobInformation: 'Інформація про роботу',
          AppliedForThisJob: 'Відгукнувся на цю заявку',
          You: 'Ви',
          Confirmed: 'Підтверджені',
          DatePosted: 'Дата публікації',
          SearchResults: 'Результати пошуку',
          ShowFilters: 'Показати фільтри',
          HideFilters: 'Приховати фільтри',
          ClickToExpandSidebarWithFilters: 'Натисніть, щоб розгорнути бічну панель із фільтрами!',
          NoJobsWereFoundForThisLocation: 'Для цього місця актуальних заявок не знайдено. Спробуйте застосувати інші фільтри',
          SelectACategory: 'Виберіть категорію',
          oneItemSelected: 'Обрано: {{count}}',
          itemsSelected: 'Обрано: {{count}}',
          CategoriesLoadError: 'Не вдалося завантажити категорії.',
          NoCategoriesAvailable: 'Немає доступних категорій',
          JobsLoadError: 'Не вдалося завантажити роботи. Спробуйте ще раз.',
          Retry: 'Повторити',
          SortBy: 'Сортування',
          NewestFirst: 'Спочатку нові',
          OldestFirst: 'Спочатку старі',
          HighestPayment: 'За оплатою',
          SomethingWentWrong: 'Щось пішло не так',
          LoadingJob: 'Завантаження замовлення...',
          JobUnavailableTitle: 'Замовлення недоступне',
          JobUnavailableMessage: 'Замовлення не знайдено або воно більше не доступне для вашого облікового запису.',
          ReloadPageMessage: 'Оновіть сторінку та спробуйте ще раз.',
          ReloadPage: 'Оновити сторінку',
          SelectANationality: 'Виберіть національність',
          SelectACurrency: 'Виберіть валюту',
          InvalidPassword: 'Пароль має бути не менше 8 та не більше 20 символів.',
          InvalidTwicePasswordMessage: 'Будь ласка, перевірте чи ви правильно ввели двічі свій пароль.',
          InvalidPhoneNumberFormat: 'Недійсний формат номера телефону',
          SmsMobileNumberRequired: 'SMS можна надіслати лише на дійсний мобільний номер. Стаціонарні номери не підтримуються.',
          IncorrectPhoneNumberOrPassword: 'Неправильний номер телефону або пароль',
          IncorrectPassword: 'Неправильний пароль',
          IncorrectPhoneNumber: 'Неправильний номер телефону',
          PhoneNotRegistered: 'Цей номер телефону не зареєстрований.',
          RegisterThisNumber: 'Зареєструвати цей номер',
          LoginUnavailable: 'Вхід тимчасово недоступний. Спробуйте пізніше.',
          SmsTooManyRequests: 'Забагато спроб надсилання SMS. Спробуйте пізніше.',
          SmsQuotaExceeded: 'Ліміт SMS вичерпано. Спробуйте пізніше або зверніться до підтримки.',
          CaptchaCheckFailed: 'Перевірка безпеки не пройшла. Оновіть сторінку та спробуйте знову.',
          PhoneAuthenticationDisabled: 'Вхід за телефоном вимкнено або SMS заборонені для цієї країни. Зверніться до підтримки.',
          SmsBillingNotEnabled: 'Оплату SMS не ввімкнено. Зверніться до підтримки.',
          SmsProviderInternalError: 'Сервіс SMS повернув внутрішню помилку. Спробуйте пізніше.',
          SmsProviderTemporarilyUnavailable: 'SMS-сервіс тимчасово відхилив запит. Зачекайте близько години та спробуйте знову або підтвердьте через email.',
          SmsNetworkError: 'Помилка мережі під час запиту SMS. Перевірте з’єднання та повторіть спробу.',
          PhoneAuthenticationDomainError: 'Реєстрація за телефоном не налаштована для цього сайту. Зверніться до підтримки.',
          SmsRequestTimeout: 'Запит на SMS тривав надто довго. Спробуйте ще раз.',
          SmsDeliveryUnavailable: 'Не вдалося надіслати SMS. Спробуйте пізніше або зверніться до підтримки.',
          InvalidSmsCode: 'Неправильний SMS-код.',
          SmsCodeExpired: 'Термін дії SMS-коду минув. Запросіть новий код.',
          ResendIn: 'Повторне надсилання через',
          RegistrationUnavailable: 'Не вдалося завершити реєстрацію. Спробуйте пізніше.',
          ConfirmByEmail: 'Підтвердити через email', ConfirmBySms: 'Підтвердити через SMS',
          PleaseCheckYourEmail: 'Перевірте електронну пошту', CheckSpamFolder: 'Також перевірте папку «Спам».',
          ChangeEmail: 'Змінити email', EmailExistsMessage: 'Цей email уже зареєстрований.',
          PhoneVerificationRequired: 'Потрібне підтвердження телефону.', PhoneOrEmail: 'Телефон або email',
          PhoneNotVerified: 'Телефон не підтверджено. Його можна підтвердити через SMS пізніше.',
          AccountNotRegistered: 'Цей обліковий запис не зареєстрований.', PasswordResetInstructionsSent: 'Якщо такий обліковий запис існує, ми надіслали інструкції для скидання пароля.',
          PasswordResetEmailRequired: 'Для скидання пароля введіть email, прив’язаний до облікового запису.',
          EmailConfirmedRegistrationCompleted: 'Email підтверджено, реєстрацію завершено.',
          EmailVerificationExpired: 'Термін дії посилання минув. Надішліть лист ще раз.',
          EmailVerificationRequired: 'Підтвердьте email перед публікацією заявки або відгуком на роботу.',
          InvalidOrExpiredResetLink: 'Посилання для скидання пароля недійсне або прострочене.',
          RegistrationCompleted: 'Реєстрацію завершено',
          RegistrationSuccessful: 'Ви успішно зареєструвалися.',
          CompleteMasterProfile: 'Заповніть профіль майстра, щоб почати отримувати заявки.',
          PleaseCheckYourPhone: 'Будь ласка, перевірте свій телефон',
          WeReSendACodeTo: 'Ми відправляємо код на',
          ClickToResend: 'Натисніть, щоб відправити повторно',
          DidntHaveACode: 'У вас не було коду?',
          Verification: 'Верифікація',
          Administrator: 'Адміністратор',
          Success: 'Успіх',
          YourDataHasBeenSuccessfullyUpdated: 'Ваші дані були успішно оновлені!',
          SaveProfileChanges: 'Зберегти зміни профілю',
          PhoneExistsMessage: 'Користувач за цим номером телефону вже зареєстрований. \nБудь ласка, увійдіть в свій акаунт або скиньте пароль, якщо ви його забули.',
          PhoneNotExistsMessage: 'Користувач за цим номером телефону не зареєстрований.',
          MasterWithoutPermission: 'Для доступу до цієї опції сервісу, будь ласка, пройдіть повну верифікацію в вашому кабінеті. В випадку, якщо ви її пройшли, будь ласка, дочекайтеся підтвердження верифікації від адміністратора сайту.',
          Only2PassportPhotos: 'Будь ласка, оберіть тільки 2 фотографії паспорту',
          UploadDocError: 'Сталася помилка під час завантаження фото. Будь ласка, повторіть цю операцію пізніше.',
          DocumentUploadCondition: 'Завантажуйте паспорт або ID-документ по одній стороні чи виберіть обидві сторони разом. Максимум 10 МБ на файл. Підтримувані формати:',
          DocumentType: 'Тип документа',
          IdCard: 'ID-картка (2 сторони)',
          PassportBooklet: 'Паспорт-книжечка (2 сторінки)',
          InternationalPassport: 'Закордонний паспорт (1 сторінка)',
          UploadPassportSidesHint: 'Завантажте лицьову та зворотну сторони окремо. Документ з ІПН необов’язковий, його можна додати пізніше.',
          PassportFrontSide: 'Лицьова сторона / сторінка з фото',
          PassportBackSide: 'Зворотна сторона / сторінка з пропискою',
          ItnOptional: 'ІПН (необов’язково)',
          DocumentFileRequired: 'Оберіть хоча б один файл документа.',
          PassportRequired: 'Завантажте хоча б лицьову сторону або сторінку паспорта з фото.',
          DocumentFileTooLarge: 'Розмір документа перевищує 10 МБ.',
          UnsupportedDocumentFormat: 'Формат документа не підтримується. Оберіть JPG, PNG, WebP, HEIC або PDF.',
          DocumentConversionFailed: 'Не вдалося перетворити фото з телефона. Спробуйте JPG, PNG або PDF.',
          DocumentsSentForReview: 'Документи завантажено та надіслано на перевірку.',
          DocumentsPendingReview: 'Документи очікують перевірки адміністратора.',
          TooManyPassportFiles: 'Оберіть не більше двох файлів паспорта одночасно.',
          DeleteCategory: 'Ви впевнені, що хочете видалити ',
          Yes: 'Так',
          No: 'Ні',
          CreateNewFAQ: 'Створити новий FAQ',
          NotValidPaymentData: 'Недійсні платіжні дані',
          hrAgo: 'години тому',
          minAgo: 'хвилин тому',
          now: 'зараз',
          RespondToTheApplication: 'Відгукнутись на заявку',
          ProposedPayment: 'Запропонований платіж',
          SuggestedLeadTime: 'Пропонований час виконання',
          ICanDoItIn: 'Я впораюся за',
          EmptyPhoneNumberMessage: 'Поле номера телефону порожнє: введіть свій номер телефону, будь ласка',
          EmptyFieldsMessage: 'Пусті поля: Будь ласка, заповніть всі поля',
          EmptyJobDateTime: 'Будь ласка, заповніть поле дати та часу',
          JobDescriptionRequired: 'Будь ласка, опишіть роботу.',
          JobLocationRequired: 'Оберіть адресу зі списку підказок.',
          JobPhotoRequired: 'Завантажте щонайменше одне фото роботи.',
          JobPublishInvalidData: 'Перевірте введені дані та спробуйте ще раз.',
          JobPublishFailed: 'Не вдалося опублікувати заявку. Спробуйте ще раз. Якщо проблема повториться, зверніться до підтримки.',
          PublishingJob: 'Публікуємо…',
          EmptyMessage: 'Порожнє повідомлення',
          AllowViewingOfMyGeolocation: 'Дозволити перегляд моєї геолокації',
          ViewGeolocation: 'Перегляд геолокації',
          ViewGeolocationTooltip: 'Ваше місцезнаходження потрібне для відображення заявок щодо роботи поблизу вас',
          DeniedPermission: 'Раніше ви відхилили дозвіл на перегляд своєї геолокації. Щоб користуватися всіма можливостями сервісу, увімкніть дозвіл на перегляд вашого місцезнаходження для нашого сайту в налаштуваннях браузера.',
          ViewPermissionNotAllowed: 'Для доступу до перегляду заявок поблизу, підтвердіть дозвіл на перегляд вашого місцезнаходження в налаштуваннях кабінету.',
          DetermineMyLocation: 'Визначити моє місцезнаходження',
          DeterminingLocation: 'Визначаємо місцезнаходження…',
          LocationStatus: 'Місцезнаходження',
          LocationDetermined: 'визначено',
          LocationNotDetermined: 'не дозволено браузером',
          EnableGeolocationHint: 'Увімкніть геолокацію, щоб бачити роботи поруч.',
          GeolocationPermissionDenied: 'Доступ до місцезнаходження заборонено.',
          GeolocationPositionUnavailable: 'Поточне місцезнаходження недоступне.',
          GeolocationTimeout: 'Не вдалося визначити місцезнаходження вчасно. Спробуйте ще раз.',
          GeolocationUnsupported: 'Цей браузер не підтримує геолокацію.',
          GeolocationSaveError: 'Місцезнаходження визначено, але не вдалося зберегти. Спробуйте ще раз.',
          GeolocationBrowserInstructions: 'Ви все одно можете шукати роботи та вибрати регіон вручну у фільтрі Location.',
          HowToEnableGeolocation: 'Як увімкнути доступ до геолокації',
          GeolocationSafariInstructions: 'Safari: Safari → Налаштування для help2fix.net → Місцезнаходження → Дозволити.',
          GeolocationMacInstructions: 'macOS: Системні налаштування → Конфіденційність і безпека → Служби геолокації → Safari.',
          GeolocationChromeInstructions: 'Chrome: значок замка в адресному рядку → Місцезнаходження → Дозволити.',
          AllCurrencies: 'Усі валюти',
          SelectCurrencyToFilterPayment: 'Виберіть валюту, щоб фільтрувати за оплатою.',
          NoOpenJobsForCurrency: 'Немає відкритих робіт у цій валюті.',
          ResetPaymentFilter: 'Скинути фільтр оплати',
          EmptyAddress: 'Порожня адреса',
          TheConfirmationLetterHasBeenSentSuccessfully: 'Лист-підтвердження успішно надіслано. Будь ласка, підтвердьте свою електронну адресу.',
          ConfirmationLetterSentTo: 'Лист для підтвердження надіслано на {{email}}. Перевірте вхідні повідомлення.',
          EmailVerificationRateLimit: 'Зачекайте одну хвилину перед повторним надсиланням листа.',
          TheEmailIsNotValid: 'Електронна адреса недійсна.',
          EmailDeliveryUnavailable: 'Надсилання електронної пошти тимчасово недоступне. Зверніться до служби підтримки.',
          EmptyNewQuestionOrAnswer: 'Нове запитання чи відповідь порожні',
          EnterANewPassword: 'Введіть новий пароль',
          PasswordReset: 'Скидання пароля',
          YourPasswordHasBeenUpdatedSuccessfully: 'Ваш пароль успішно оновлено',
          InvalidCode: 'Невірний код',
          ImageLoadingCondition: 'Розмір кожного зображення не повинен перевищувати 6 МБ і бути в одному з наступних форматів:',
          ImageSizeNotice: 'Розмір зображення або зображень завеликий. Будь ласка, оберіть інше або інші зображення.',
          ImageTypeNotice: 'Недійсний формат зображення або зображень. Будь ласка, оберіть інше чи інші зображення.',
          Reset: 'Скинути',
          ResetAllImages: 'Скинути всі зображення',
        }      
      },
      cs: {
        translation: {
          Home: 'Hlavní',
          PostAJob: 'Vytvořte aplikaci',
          About: 'O nás',
          Support: 'Podpora',
          AdminPanel: 'Administrátorská lišta',
          Statistics: 'Statistika',
          Office: 'Moje kancelář',
          Howdy: 'Ahoj',
          Greetings: 'Jsme rádi, že vás zase vidíme!',
          ManageJobs: 'Správa aplikací',
          LogInRegister: 'Přihlásit se / Registrovat',
          Register: 'Registrovat',
          LogIn: 'Přihlásit se',
          DontHaveAnAccount: 'Nemáte účet?',
          SignUp: 'Přihlásit se!',
          PhoneNumber: 'Telefonní číslo',
          Phone: 'Telefonn',
          Password: 'Heslo',
          RepeatPassword: 'Zopakovat heslo',
          TrustThisDevice: 'Důvěřujte tomuto zařízení',
          ForgotPassword: 'Zapomenuté heslo?',
          LetsCreateYourAccount: 'Pojďme vytvořit váš účet!',
          Client: 'Klient',
          Master: 'Mistr',
          FirstName: `Název`,
          LastName: 'Příjmení',
          Notifications: 'Oznámení',
          AcceptCandidate: 'Přijmout kandidáta',
          Decline: 'Odmítnout',
          DeclineCandidate: 'Odmítnout kandidáta',
          DeclineCandidateQuestion: 'Odmítnout kandidáta {{name}} pro tuto práci?',
          Cancel: 'Zrušit',
          CandidateAccepted: 'Kandidát přijat',
          JobCompleted: 'Práce dokončena',
          CompleteAndRate: 'Dokončit a ohodnotit',
          RateMasterRequired: 'Ohodnoťte řemeslníka (povinné)',
          ReviewOptional: 'Recenze (volitelné)',
          RatingRequired: 'Vyberte hodnocení od 1 do 5 hvězdiček.',
          JobCompletionFailed: 'Práci se nepodařilo dokončit. Zkuste to znovu.',
          InvalidJobCompletionData: 'Vyberte platné hodnocení.',
          CommentTooLong: 'Recenze nesmí překročit 255 znaků.',
          AcceptedMasterNotFound: 'Pro tuto práci nebyl nalezen přijatý řemeslník.',
          JobAlreadyCompleted: 'Tato práce již byla dokončena.',
          CompletionSavedThanks: 'Děkujeme! Práce byla dokončena a hodnocení uloženo.',
          Completed: 'Dokončeno',
          Saving: 'Ukládání...',
          JobCompletedNotification: 'dokončil(a) práci a ohodnotil(a) vás za',
          VerifiedMaster: 'Ověřený mistr',
          CandidateAcceptedNotification: 'vás přijal(a) na práci',
          CandidateDeclinedNotification: 'odmítl(a) vaši žádost o práci',
          MasterAppliedNotification: 'se přihlásil(a) na',
          NewJobNotification: 'zveřejnil(a) novou práci',
          NewJobsAvailable: 'Nové práce ({{count}}) — zobrazit',
          NewCandidatesCount: '{{count}} nových',
          YouWereAccepted: 'Byli jste přijati',
          MarkAllAsRead: 'Označit vše jako přečtené',
          appliedForAJob: 'podal přihlášku',
          YouHaveNoUnreadNotifications: 'Nemáte žádná nepřečtená oznámení',
          YouHaveNoUnreadMessages: 'Nemáte žádné nepřečtené zprávy',
          ViewAllMessages: 'Zobrazit všechny zprávy',
          Messages: 'Zprávy',
          Settings: 'Nastavení',
          Logout: 'Odhlásit se',
          mainDescription: {
            part1: `Najměte si mistry nebo buďte kdykoli najati na jakoukoli práci.`,
            part2: `Tisíce uživatelů používají `,
            part3: ` pro rychlá řešení každodenních problémů.`
          },
          Search: 'Vyhledávání',
          Where: 'Kde?',
          Place: 'Místo',
          WhatJobYouWant: 'Jakou práci chceš?',
          JobTitle: 'Pracovní pozice',
          JobCategory: 'Kategorie aplikace',
          JobsPosted: 'Zveřejněná volná místa',
          Masters: 'Mistrů',
          PopularJobCategories: 'Oblíbené pracovní kategorie',
          Categories: 'Tsategoris',
          RecentJobs: 'Nejnovější aplikace',
          BrowseAllJobs: 'Zobrazit všechny aplikace',
          daysAgo: 'dny',
          OneDayAgo: 'před 1 dnem',
          ApplyNow: 'Odpověz teď',
          ApplyForAJob: 'Odpovězte na žádost',
          HighestRatedMasters: 'Mistři s nejvyšším hodnocením',
          BrowseAllMasters: 'Zobrazit všechny mistry',
          MasterProfile: 'Profil mistra',
          ViewProfile: 'Prohlédnout profil',
          ForMasters: 'Pro mistry',
          ForClients: 'Pro klienty',
          BrowseJobs: 'Zobrazit aplikace',
          BrowseCandidates: 'Prohlížení kandidátů',
          Contact: 'Kontakt',
          PrivacyPolicy: 'Zásady ochrany osobních údajů',
          CookieSettings: 'Nastavení cookies',
          CookieConsentTitle: 'Nastavení souborů cookie',
          CookieConsentText: 'Používáme nezbytné úložiště pro přihlášení, zabezpečení a nastavení. S vaším souhlasem může Google Maps získat technické údaje, například IP adresu.',
          CookieNecessaryOnly: 'Odmítnout volitelné',
          CookieAcceptAll: 'Přijmout volitelné',
          MapConsentRequired: 'Google Maps je vypnutá, dokud nepovolíte volitelné služby.',
          OpenCookieSettings: 'Otevřít nastavení cookies',
          LearnMore: 'Více informací',
          PrivacyPolicyIntro: 'HELP 2 FIX zpracovává údaje o účtu, kontaktní údaje a informace o zakázkách za účelem poskytování služeb klientům a mistrům.',
          EssentialStorageTitle: 'Nezbytné úložiště',
          EssentialStorageText: 'Nezbytné cookies a místní úložiště zajišťují přihlášení, zabezpečení, volbu jazyka a uložení souhlasu. Jsou nutné pro fungování webu.',
          OptionalServicesTitle: 'Externí a volitelné služby',
          OptionalServicesText: 'Některé stránky používají Google Maps k zobrazení polohy. Google může zpracovávat technické informace podle vlastních podmínek ochrany soukromí. Web nyní nepoužívá reklamní pixely.',
          CookieChoiceTitle: 'Správa vaší volby',
          CookieChoiceText: 'Vaše volba je uložena v tomto prohlížeči. Panel souhlasu můžete kdykoli znovu otevřít pomocí Nastavení cookies v zápatí.',
          PrivacyContactText: 'V případě dotazů k ochraně soukromí nás kontaktujte na',
          Account: 'Účet',
          MyAccount: 'Můj účet',
          AllRightsReserved: 'Všechna práva vyhrazena.',
          HelpfulLinks: 'Užitečné odkazy',
          OfficeNavigation: 'Navigace v kanceláři',
          ViewMasterProfile: 'Zobrazení profilu mistra',
          Start: 'Start',
          MyJobListing: 'Můj seznam aplikací',
          JobSubmissionForm: 'Přihláška',
          Loading: 'Načítání',
          Payment: 'Způsob platby',
          DateAndTime: 'Datum a čas',
          JobDescription: 'Popis práce',
          ImagesThatMightBeHelpfulInDescribingYourJob: 'Obrázky, které mohou být užitečné při popisu vaší práce',
          UploadPhotos: 'Nahrát fotky',
          PhotoUploadConstraints: 'Až {{count}} fotografií, maximálně {{size}} MB každá. Formáty:',
          SelectedPhotosCount: 'Vybráno: {{selected}} / {{count}}',
          MaximumJobPhotos: 'Můžete nahrát nejvýše {{count}} fotografií.',
          RemovePhoto: 'Odstranit fotografii',
          JobPhoto: 'Fotografie zakázky',
          Upload: 'Nahrát',
          TypeAddress: 'Zadejte adresu',
          Posted: 'Vyslán',
          ExpiringOn: 'Vyprší dne',
          MyMaster: 'Můj pán',
          ManageCandidates: 'Vedení kandidátů',
          Job: 'Aplikace',
          jobStatus: {
            PendingApproval: 'Čeká na schválení',
            Expiring: 'Končí platnost',
            Expired: 'Platnost vypršela'
          },
          ConfirmTheWorkDone: 'Potvrďte vykonanou práci',
          SaveNewAvatar: 'Uložit nového avatara',
          Uploading: 'Nahrávání…',
          AvatarUpdatedSuccessfully: 'Profilová fotografie byla aktualizována.',
          UnsupportedAvatarFormat: 'Nepodporovaný formát. Vyberte obrázek JPG, PNG nebo WebP.',
          AvatarFileTooLarge: 'Soubor je příliš velký. Maximální velikost je 5 MB.',
          AvatarFileRequired: 'Vyberte obrázek k nahrání.',
          AvatarUploadFailed: 'Fotografii se nepodařilo nahrát. Zkuste to znovu nebo vyberte jiný soubor.',
          AccountType: 'Typ účtu',
          Verified: 'Ověřeno',
          Verify: 'Ověření',
          Tagline: 'Tagline',
          YourMessage: 'Vaše zpráva',
          Send: 'Poslat',
          DeleteConversation: 'Smazat konverzaci',
          CompletedJobs: 'Dokončené přihlášky',
          TotalAmountEarned: 'Celkový vydělaný Amont',
          JobQRScanner: 'QR-skener vyplněné žádosti',
          ViewJobs: 'Zobrazit aktuální aplikace',
          MyProfile: 'Můj profil',
          Nationality: 'Národnost',
          IntroduceYourself: 'Představit se',
          UploadPassportPhotos: 'Nahrajte pasové fotografie',
          Passport: 'Pas',
          UploadAPhotoOfYourTaxIdentificationNumber: 'Nahrajte fotografii svého daňového identifikačního čísla',
          MyDocuments: 'Moje dokumenty',
          NewJobs: 'Nové aplikace',
          NewMasters: 'Noví mistři',
          AdminPanelNavigation: 'Navigace v panelu administrátora',
          VerifyTheDocuments: 'Ověřte dokumenty',
          Edit: 'Upravit',
          AddJobCategory: 'Přidat kategorii práce',
          VerificationOfDocuments: 'Ověřování dokladů',
          Editing: 'Editace',
          AddingJobCategories: 'Přidání pracovních kategorií',
          More: 'Více',
          Documents: 'Dokumenty',
          NewMaster: 'Nový Mistr',
          SaveChanges: 'Uložit změny',
          Saving: 'Ukládání...',
          FirstAndLastNameAreRequired: 'Jméno a příjmení jsou povinné.',
          CouldNotUpdateProfile: 'Profil se nepodařilo aktualizovat. Zkuste to znovu.',
          NewCategory: 'Nová kategorie',
          Description: 'Popis',
          isPopular: 'je populární',
          Create: 'Vytvořit',
          AllCategories: 'Všechny kategorie',
          TheMasterDidntProvideAnyDocuments: 'Mistr nepředložil žádné dokumenty',
          Question: 'Otázka',
          Answer: 'Odpovědět',
          AboutMe: 'O mně',
          WorkHistoryAndFeedback: 'Historie práce a zpětná vazba',
          RatedAs: 'Hodnoceno jako',
          JobsDone: 'Hotovo',
          Rehired: 'Znovu přijati',
          ConfirmedMaster: 'Potvrzený Mistr',
          Candidate: {
            part1: 'Kandidát',
            part2: 'і'
          },
          For: 'Pro',
          SendMessage: 'Poslat zprávu',
          Remove: 'Odstranit',
          Accept: 'Akceptovat',
          AnyQuestionsFeelFreeToContactUs: 'Nějaké otázky? Neváhejte nás kontaktovat!',
          Confirm: 'Potvrdit',
          Users: 'Uživatelé',
          Location: 'Umístění',
          Category: 'Kategorie',
          Currency: 'Měna',
          WhatSpecialistDoYouNeed: 'Jakého specialistu potřebujete?',
          ContactUs: 'Kontaktujte nás',
          Menu: 'Menu',
          CloseMenu: 'Zavřít menu',
          OurOffice: 'Naše Kancelář',
          BecomeAMaster: 'Staňte se mistrem',
          MinPayment: 'Minimální poplatek',
          MaxPayment: 'Maximální nabití',
          AboutTheClient: 'O Klientovi',
          JobDescription: 'Popis práce',
          JobInformation: 'Informace o práci',
          AppliedForThisJob: 'Odpověděl na tuto aplikaci',
          You: 'Vy',
          Confirmed: 'Potvrzeno',
          DatePosted: 'Datum zveřejnění',
          SearchResults: 'Výsledky vyhledávání',
          ShowFilters: 'Zobrazit filtry',
          HideFilters: 'Skrýt filtry',
          ClickToExpandSidebarWithFilters: 'Kliknutím rozbalíte postranní panel s filtry!',
          NoJobsWereFoundForThisLocation: 'Na tuto pozici nebyly nalezeny žádné aktuální přihlášky. Zkuste použít jiné filtry',
          SelectACategory: 'Vyberte kategorii',
          oneItemSelected: 'Vybrána {{count}} položka',
          itemsSelected: 'Vybráno položek: {{count}}',
          CategoriesLoadError: 'Kategorie se nepodařilo načíst.',
          NoCategoriesAvailable: 'Nejsou dostupné žádné kategorie',
          JobsLoadError: 'Práce se nepodařilo načíst. Zkuste to znovu.',
          Retry: 'Zkusit znovu',
          SortBy: 'Řazení',
          NewestFirst: 'Nejnovější první',
          OldestFirst: 'Nejstarší první',
          HighestPayment: 'Podle odměny',
          SomethingWentWrong: 'Něco se pokazilo',
          LoadingJob: 'Načítání zakázky...',
          JobUnavailableTitle: 'Zakázka není dostupná',
          JobUnavailableMessage: 'Zakázka nebyla nalezena nebo již není pro váš účet dostupná.',
          ReloadPageMessage: 'Obnovte stránku a zkuste to znovu.',
          ReloadPage: 'Obnovit stránku',
          SelectANationality: 'Виберіть національність',
          SelectACurrency: 'Vyberte měnu',
          InvalidPassword: 'Heslo musí mít alespoň 8 a ne více než 20 znaků.',
          InvalidTwicePasswordMessage: 'Zkontrolujte, zda jste heslo zadali správně dvakrát.',
          InvalidPhoneNumberFormat: 'Neplatný formát telefonního čísla',
          SmsMobileNumberRequired: 'SMS lze odeslat pouze na platné mobilní číslo. Pevné linky nejsou podporovány.',
          IncorrectPhoneNumberOrPassword: 'Nesprávné telefonní číslo nebo heslo',
          IncorrectPassword: 'Nesprávné heslo',
          IncorrectPhoneNumber: 'Nesprávné telefonní číslo',
          PhoneNotRegistered: 'Toto telefonní číslo není registrováno.',
          RegisterThisNumber: 'Zaregistrovat toto číslo',
          LoginUnavailable: 'Přihlášení je dočasně nedostupné. Zkuste to později.',
          SmsTooManyRequests: 'Příliš mnoho pokusů o SMS. Zkuste to později.',
          SmsQuotaExceeded: 'Limit SMS byl vyčerpán. Zkuste to později nebo kontaktujte podporu.',
          CaptchaCheckFailed: 'Bezpečnostní kontrola selhala. Obnovte stránku a zkuste to znovu.',
          PhoneAuthenticationDisabled: 'Telefonní přihlášení je vypnuté nebo SMS nejsou pro tuto zemi povoleny. Kontaktujte podporu.',
          SmsBillingNotEnabled: 'Fakturace SMS není zapnutá. Kontaktujte podporu.',
          SmsProviderInternalError: 'Poskytovatel SMS vrátil interní chybu. Zkuste to později.',
          SmsProviderTemporarilyUnavailable: 'Poskytovatel SMS požadavek dočasně odmítl. Počkejte přibližně hodinu a zkuste to znovu nebo potvrďte e-mailem.',
          SmsNetworkError: 'Chyba sítě při požadavku na SMS. Zkontrolujte připojení a zkuste to znovu.',
          PhoneAuthenticationDomainError: 'Registrace telefonem není pro tento web nastavena. Kontaktujte podporu.',
          SmsRequestTimeout: 'Požadavek na SMS trval příliš dlouho. Zkuste to znovu.',
          SmsDeliveryUnavailable: 'SMS se nepodařilo odeslat. Zkuste to později nebo kontaktujte podporu.',
          InvalidSmsCode: 'SMS kód je nesprávný.',
          SmsCodeExpired: 'Platnost SMS kódu vypršela. Vyžádejte si nový kód.',
          ResendIn: 'Znovu odeslat za',
          RegistrationUnavailable: 'Registraci se nepodařilo dokončit. Zkuste to později.',
          ConfirmByEmail: 'Potvrdit e-mailem', ConfirmBySms: 'Potvrdit SMS',
          PleaseCheckYourEmail: 'Zkontrolujte svůj e-mail', CheckSpamFolder: 'Zkontrolujte také složku Spam.',
          ChangeEmail: 'Změnit e-mail', EmailExistsMessage: 'Tento e-mail je již registrován.',
          PhoneVerificationRequired: 'Je vyžadováno ověření telefonu.', PhoneOrEmail: 'Telefon nebo e-mail',
          PhoneNotVerified: 'Telefon není ověřen. Později jej můžete ověřit pomocí SMS.',
          AccountNotRegistered: 'Tento účet není registrován.', PasswordResetInstructionsSent: 'Pokud účet existuje, odeslali jsme pokyny k obnovení hesla.',
          PasswordResetEmailRequired: 'Pro obnovení hesla zadejte e-mail propojený s účtem.',
          EmailConfirmedRegistrationCompleted: 'E-mail byl potvrzen, registrace je dokončena.',
          EmailVerificationExpired: 'Platnost potvrzovacího odkazu vypršela. Odešlete e-mail znovu.',
          EmailVerificationRequired: 'Před zveřejněním nebo reakcí na práci potvrďte svůj e-mail.',
          InvalidOrExpiredResetLink: 'Odkaz pro obnovení hesla je neplatný nebo vypršel.',
          RegistrationCompleted: 'Registrace dokončena',
          RegistrationSuccessful: 'Registrace byla úspěšná.',
          CompleteMasterProfile: 'Vyplňte profil mistra a začněte přijímat zakázky.',
          PleaseCheckYourPhone: 'Zkontrolujte svůj telefon',
          WeReSendACodeTo: 'Odesíláme kód na',
          ClickToResend: 'Klikněte pro opětovné odeslání',
          DidntHaveACode: 'Neměli jste kód?',
          Verification: 'Ověřování',
          Administrator: 'Správce',
          Success: 'Úspěch',
          YourDataHasBeenSuccessfullyUpdated: 'Vaše data byla úspěšně aktualizována!',
          SaveProfileChanges: 'Uložení změn profilu',
          PhoneExistsMessage: 'Uživatel s tímto telefonním číslem je již zaregistrován. \nPřihlaste se prosím ke svému účtu nebo si resetujte heslo, pokud jste jej zapomněli.',
          PhoneNotExistsMessage: 'Uživatel s tímto telefonním číslem není registrován.',
          MasterWithoutPermission: 'Chcete-li získat přístup k této možnosti služby, proveďte úplné ověření ve svém účtu. Pokud jste ji prošli, vyčkejte prosím na potvrzení ověření od správce webu.',
          Only2PassportPhotos: 'Vyberte prosím pouze 2 pasové fotografie',
          UploadDocError: 'Při nahrávání fotografie došlo k chybě. Zkuste prosím tuto operaci znovu později.',
          DocumentUploadCondition: 'Nahrajte pas nebo doklad po jedné straně, případně vyberte obě strany najednou. Maximálně 10 MB na soubor. Podporované formáty:',
          DocumentType: 'Typ dokumentu',
          IdCard: 'Občanský průkaz (2 strany)',
          PassportBooklet: 'Cestovní pas - knížka (2 strany)',
          InternationalPassport: 'Mezinárodní pas (1 strana)',
          UploadPassportSidesHint: 'Nahrajte přední a zadní stranu samostatně. Daňové identifikační číslo je volitelné a lze jej přidat později.',
          PassportFrontSide: 'Přední strana / stránka s fotografií',
          PassportBackSide: 'Zadní strana / registrační stránka',
          ItnOptional: 'Daňové identifikační číslo (volitelné)',
          DocumentFileRequired: 'Vyberte alespoň jeden soubor dokumentu.',
          PassportRequired: 'Nahrajte alespoň přední stranu nebo stránku pasu s fotografií.',
          DocumentFileTooLarge: 'Dokument je větší než 10 MB.',
          UnsupportedDocumentFormat: 'Nepodporovaný formát dokumentu. Vyberte JPG, PNG, WebP, HEIC nebo PDF.',
          DocumentConversionFailed: 'Fotografii z telefonu se nepodařilo převést. Zkuste JPG, PNG nebo PDF.',
          DocumentsSentForReview: 'Dokumenty byly nahrány a odeslány ke kontrole.',
          DocumentsPendingReview: 'Dokumenty čekají na kontrolu administrátorem.',
          TooManyPassportFiles: 'Vyberte najednou nejvýše dva soubory pasu.',
          DeleteCategory: 'Opravdu chcete smazat ',
          Yes: 'Ano',
          No: 'Ne',
          CreateNewFAQ: 'Vytvořit nové FAQ',
          NotValidPaymentData: 'NotValidPaymentData',
          hrAgo: 'hodinami',
          minAgo: 'minutami',
          now: 'Nyní',
          RespondToTheApplication: 'Odpovězte na žádost',
          ProposedPayment: 'Navrhovaná platba',
          SuggestedLeadTime: 'Doporučená dodací lhůta',
          ICanDoItIn: 'Zvládnu to za',
          EmptyPhoneNumberMessage: 'Pole pro telefonní číslo je prázdné: zadejte prosím své telefonní číslo',
          EmptyFieldsMessage: 'Prázdná pole: Vyplňte prosím všechna pole',
          EmptyJobDateTime: 'Vyplňte prosím pole data a času',
          JobDescriptionRequired: 'Popište prosím práci.',
          JobLocationRequired: 'Vyberte adresu z nabídky našeptávače.',
          JobPhotoRequired: 'Nahrajte alespoň jednu fotografii práce.',
          JobPublishInvalidData: 'Zkontrolujte zadané údaje a zkuste to znovu.',
          JobPublishFailed: 'Zakázku se nepodařilo zveřejnit. Zkuste to znovu. Pokud problém přetrvává, kontaktujte podporu.',
          PublishingJob: 'Zveřejňování…',
          EmptyMessage: 'Prázdná zpráva',
          AllowViewingOfMyGeolocation: 'Povolit zobrazení mé geolokace',
          ViewGeolocation: 'Zobrazit geolokaci',
          ViewGeolocationTooltip: 'K zobrazení žádostí o zaměstnání ve vaší blízkosti je vyžadována vaše poloha',
          DeniedPermission: 'Dříve jste odmítli oprávnění zobrazit svou geolokaci. Chcete-li využívat všechny funkce služby, povolte v nastavení prohlížeče oprávnění k zobrazení vaší polohy pro naše stránky.',
          ViewPermissionNotAllowed: 'Chcete-li získat přístup k prohlížení aplikací v okolí, potvrďte oprávnění k zobrazení vaší polohy v nastavení účtu.',
          DetermineMyLocation: 'Zjistit moji polohu',
          DeterminingLocation: 'Zjišťování polohy…',
          LocationStatus: 'Poloha',
          LocationDetermined: 'zjištěna',
          LocationNotDetermined: 'není povolena prohlížečem',
          EnableGeolocationHint: 'Zapněte geolokaci, abyste viděli práce ve svém okolí.',
          GeolocationPermissionDenied: 'Přístup k poloze byl zamítnut.',
          GeolocationPositionUnavailable: 'Vaše aktuální poloha není dostupná.',
          GeolocationTimeout: 'Zjištění polohy trvalo příliš dlouho. Zkuste to znovu.',
          GeolocationUnsupported: 'Tento prohlížeč nepodporuje geolokaci.',
          GeolocationSaveError: 'Poloha byla zjištěna, ale nepodařilo se ji uložit. Zkuste to znovu.',
          GeolocationBrowserInstructions: 'Stále můžete hledat práce a vybrat oblast ručně ve filtru Location.',
          HowToEnableGeolocation: 'Jak povolit přístup k poloze',
          GeolocationSafariInstructions: 'Safari: Safari → Nastavení pro help2fix.net → Poloha → Povolit.',
          GeolocationMacInstructions: 'macOS: Nastavení systému → Soukromí a zabezpečení → Polohové služby → Safari.',
          GeolocationChromeInstructions: 'Chrome: ikona zámku v adresním řádku → Poloha → Povolit.',
          AllCurrencies: 'Všechny měny',
          SelectCurrencyToFilterPayment: 'Vyberte měnu pro filtrování podle platby.',
          NoOpenJobsForCurrency: 'V této měně nejsou žádné otevřené práce.',
          ResetPaymentFilter: 'Obnovit filtr platby',
          EmptyAddress: 'Prázdná adresa',
          TheConfirmationLetterHasBeenSentSuccessfully: 'Potvrzující dopis byl úspěšně odeslán. Prosím, potvrďte svůj email.',
          ConfirmationLetterSentTo: 'Potvrzovací e-mail byl odeslán na adresu {{email}}. Zkontrolujte doručenou poštu.',
          EmailVerificationRateLimit: 'Před dalším odesláním potvrzovacího e-mailu počkejte jednu minutu.',
          TheEmailIsNotValid: 'E-mail není platný.',
          EmailDeliveryUnavailable: 'Odesílání e-mailů je dočasně nedostupné. Kontaktujte prosím podporu.',
          EmptyNewQuestionOrAnswer: 'Nová otázka nebo odpověď je prázdná',
          EnterANewPassword: 'vložte nové heslo',
          PasswordReset: 'Resetovat heslo',
          YourPasswordHasBeenUpdatedSuccessfully: 'Vaše heslo bylo úspěšně aktualizováno',
          InvalidCode: 'Neplatný kód',
          ImageLoadingCondition: 'Velikost každého obrázku nesmí přesáhnout 6 MB a musí být v jednom z následujících formátů:',
          ImageSizeNotice: 'Velikost obrázku nebo obrázků je příliš velká. Vyberte prosím jiný obrázek nebo obrázky.',
          ImageTypeNotice: 'Neplatný formát obrázku nebo obrázků. Vyberte prosím jiný obrázek nebo obrázky.',
          Reset: 'Resetovat',
          ResetAllImages: 'Obnovit všechny obrázky',
        }
      },
    }
  });

export default i18n;
